import { Http } from '@/lib/http';

export class CurrencyRateSettingsService extends Http {
  constructor() {
    super();
    this.endpoint = 'settings/company-settings/currencies';
  }

  getCurrencyRateSettings() {
    return this,this.httpClient().get(`${this.endpoint}/`)
  }

  updateCurrencyRateSetting({ id, payload }) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, payload);
  }
}
